export const GET_ARTICLES = "/get-articles";
export const GET_USERS = "/get-users";
export const GET_CATEGORIES = "/categories";
export const CREATE_CATEGORY = "/categories";
export const DELETE_CATEGORY = "/categories";
export const DELETE_ARTICLE = "/articles";
export const ENABLE_CATEGORY = "/categories";
export const TOGGLE_CATEGORY_STATUS = "/categories";
export const GET_SUBCATEGORIES = "/categories";
export const CREATE_SUBCATEGORY = "/categories";
export const TOGGLE_SUBCATEGORY_STATUS = "/subcategories";
export const DELETE_SUBCATEGORY = "/subcategories";
export const TOGGLE_WRITER_STATUS = "/writers";
export const GET_BANNERS = "/banners";
export const GET_BANNER_CLICKS = "/banners";
export const CREATE_BANNER = "/banners";
export const TOGGLE_BANNER_STATUS = "/banners";
export const DELETE_BANNER = "/banners";
export const GET_DASHBOARD = "/dashboard";
export const GET_VISITORS = "/visitors";
export const GET_VISITOR_SUMMARY = "/visitors/summary";
export const GET_VISITORS_CHART = "/visitors/chart";
export const GET_VISITOR_PAGES = "/visitors/pages";
export const LOGIN_ADMIN = "/auth/login";
